import { LogoImage } from "@/components/products/shared/LogoImage"

const logoList = [
  "google",
  "binance",
  "bloomberg",
  "coingecko",
  "morgan-stanley",
  "franklin-templeton",
  "vaneck",
  "coinbase-ventures",
  "bitwise",
  "harvard-business",
  "standard-chartered",
  "messari",
  "nansen",
  "grayscale",
  "pantera",
  "brevan-howard",
  "dragonfly",
  "coindesk",
  "ark-invest",
  "jeffries",
  "falconx",
  "arca",
  "goldentree-asset-management",
  "optimisim",
]

const CustomerGrid = () => {
  const logos = logoList.slice(0, 20)

  return (
    <div
      className="flex flex-col gap-2 items-center py-16 animate-fade-in-up"
      style={{
        opacity: 0,
        animationDelay: "0.5s",
      }}
    >
      <div className="text-fg-secondary text-base mb-4 lg:mb-6 max-w-[490px]">Trusted by</div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 items-center justify-center justify-items-center">
        {logos.map((logo) => (
          <LogoImage
            key={logo}
            logoId={logo}
            alt={logo}
            width={520}
            height={500}
            className="w-full h-[120px]"
          />
        ))}
      </div>
    </div>
  )
}

export default CustomerGrid
